import React from 'react';
import MiddleLink from '../components/MiddleLink';
import '../css/homeCaseStudies.css';

function HomeCaseStudies()
{
    return (
        <>
        <p className="bww-question">Case Studies</p>
        <div className="bww-grid-container">
            <MiddleLink to="/case-quickenloans" className="bww-grid-item">
                <h3>QuickenLoans.com</h3>
                <p>Two-phase acquisition & replatform for marketplace rebrand</p>
            </MiddleLink>
            <MiddleLink to="/case-rnf" className="bww-grid-item">
                <h3>Richard Nixon Foundation</h3>
                <p>ID & research/media hub for presidential library</p>
            </MiddleLink>
            <MiddleLink to="/case-leadgen" className="bww-grid-item">
                <h3>Lead-gen websites</h3>
                <p>SEO- and performance-focused info publishing sites for loan originators</p>
            </MiddleLink>
            {/* <MiddleLink to="/work-lenovo" className="bww-grid-item">
                <h3>Lenovo Game State</h3>
                <p>Gamified engagement platform</p>
            </MiddleLink>
            <MiddleLink to="/work-chatbot" className="bww-grid-item">
                <h3>AI-powered chatbot</h3>
                <p>Claude-driven chatbot having financial advice material as RAG</p>
            </MiddleLink>
            <MiddleLink to="/work-nerdist" className="bww-grid-item">
                <h3>Nerdist.com</h3>
                <p>Busy pop culture multi-media hub</p>
            </MiddleLink> */}
        </div>
        </>
    )
}

export default HomeCaseStudies;